'use client';

import React from "react";
import styles from './NotFound.module.scss';
import Button from "@/app/[lang]/components/ui/Button";

const NotFound = () => {
  return(
    <section className={styles.wrapper}>
      <div className="container">
        <h2>404</h2>
        <p>Ne pare rău, nu am găsit pagina pe care o cauți.</p>

        <Button
          attributes={{
            type: "outline",
            backgroundColor: "white",
            textColor: "white",
            hoverColor: "light-blue",
            url: "/"
          }}
        >
          Înapoi la pagina principală
        </Button>
      </div>
    </section>
  )
};

export default NotFound;